import firebase from 'firebase/app';
import 'firebase/storage';
import {
  ADD_FRIEND_TO_DRAFT_SUCCESS,
  ADD_TEXT_TO_DRAFT_SUCCESS,
  ADD_IMAGE_TO_DRAFT_SUCCESS,
  REMOVE_IMAGE_FROM_DRAFT_SUCCESS,
  ADD_DATE_TO_DRAFT_SUCCESS,
  ADD_LOCATION_TO_DRAFT_SUCCESS,
  DRAFT_CREATE_SUCCESS,
  DRAFT_CREATE_ERROR,
} from './types';
import { baseUrl } from '../constants/baseUrl';
import { fetchWithAccessToken } from './helperAction';

export const addFriendToDraft = (friend) => (dispatch) => {
  dispatch({
    type: ADD_FRIEND_TO_DRAFT_SUCCESS,
    payload: friend,
  });
};

export const addTextToDraft = (text) => (dispatch) => {
  dispatch({
    type: ADD_TEXT_TO_DRAFT_SUCCESS,
    payload: text,
  });
};

export const addImageToDraft = (element) => (dispatch) => {
  dispatch({
    type: ADD_IMAGE_TO_DRAFT_SUCCESS,
    payload: element,
  });
};

export const removeImageFromDraft = (image) => (dispatch) => {
  dispatch({
    type: REMOVE_IMAGE_FROM_DRAFT_SUCCESS,
    payload: image,
  });
};

export const addDateToDraft = (date) => (dispatch) => {
  dispatch({
    type: ADD_DATE_TO_DRAFT_SUCCESS,
    payload: date,
  });
};

export const addLocationToDraft = (location) => (dispatch) => {
  dispatch({
    type: ADD_LOCATION_TO_DRAFT_SUCCESS,
    payload: location,
  });
};

export const sendDraft = (currentUserId) => async (dispatch, getState) => {
  const uploadImageToFirebase = async (uri) => {
    try {
      // eslint-disable-next-line max-len
      const imageName =
        (await Math.random().toString(36).substring(2, 15)) +
        Math.random().toString(36).substring(2, 15);
      const response = await fetch(uri);
      const blob = await response.blob();

      const ref = await firebase.storage().ref().child(`images/${imageName}`);
      await ref.put(blob).then(() => {});
      const downloadURL = await ref.getDownloadURL();
      return downloadURL;
    } catch (error) {
      error.log(error);
      return null;
    }
  };

  const getFirebaseUrls = async (images) => {
    if (images.length > 0) {
      const arr = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const image of images) {
        // eslint-disable-next-line no-await-in-loop
        const firebaseImage = await uploadImageToFirebase(image);
        arr.push(firebaseImage);
      }
      return arr;
    }
    return [];
  };

  let { text, friend, date, location } = getState().draft;

  const { images } = getState().draft;

  try {
    const imagesFirebase = await getFirebaseUrls(images);
    text = text || 'Turtlet Text'; // default Text until safety implemented
    date = date || new Date(Date.now() + 2 * 60 * 60 * 1000); // default Date if error
    friend = friend.id || '29d85a2b-9296-42f3-941c-5a5a7101eeb2';
    location = location || 'undefined';

    const message = {
      text,
      delivered: false,
      deliverAt: date,
      sender: currentUserId, // von current user die id holen !!!!!!!!
      recipient: friend, // von ausgewählten user die id holen !!!!!!!
      images: imagesFirebase,
      draft: false,
      location,
      read: false,
    };

    const response = await dispatch(
      fetchWithAccessToken({
        url: `${baseUrl}message`,
        method: 'POST',
        body: JSON.stringify(message),
      }),
    );

    await response.json();

    switch (response.status) {
      case 201:
      case 200:
        dispatch({
          type: DRAFT_CREATE_SUCCESS,
        });
        return true;
      default:
        dispatch({
          type: DRAFT_CREATE_ERROR,
        });
        return false;
    }
  } catch (e) {
    dispatch({ type: DRAFT_CREATE_ERROR });
    return false;
  }
};
